import React from "react";
import HomeProductCard from "./HomeProductCard";
import HomeCarsoul from "./Carsoul/HomeCarsoul";
import CenterMode from "./Carsoul/SmaillHomeCarsoul";
import { homeSlider } from "../news/newsData";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const Home = () => {
  const { data, isLoading } = useQuery({
    queryKey: "getusers",
    queryFn: () =>
      axios.get(`${BASEURL}company-intro`).then((res) => {
        return res.data;
      }),
  });
  return (
    <div>
      {isLoading && <Skeleton className="w-full h-[100vh]" />}
      {!isLoading && <HomeCarsoul sliderData={data?.companyIntros} />}
      <HomeProductCard />
    </div>
  );
};

export default Home;
